import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '@/components/Navbar';
import { EnvelopeSimple, CheckCircle } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) { console.error('Forgot password failed:', err); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-background" data-testid="forgot-password-page">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-20 fade-up">
        {sent ? (
          <div className="bg-card border border-border/70 rounded-2xl shadow-soft p-8 text-center">
            <div className="w-14 h-14 bg-emerald-500/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <CheckCircle size={30} weight="fill" className="text-emerald-600" />
            </div>
            <h1 className="font-heading text-2xl text-foreground mb-2">Check your inbox</h1>
            <p className="text-sm text-muted-foreground leading-relaxed" data-testid="forgot-sent">
              If an account exists for <span className="font-medium">{email}</span>, we've sent a password reset link. It expires in 1 hour.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-card border border-border/70 rounded-2xl shadow-soft p-8">
            <div className="w-12 h-12 bg-secondary rounded-2xl flex items-center justify-center mb-4">
              <EnvelopeSimple size={24} className="text-primary" />
            </div>
            <h1 className="font-heading text-2xl text-foreground mb-2">Forgot your password?</h1>
            <p className="text-sm text-muted-foreground mb-6">Enter your email and we'll send you a link to reset it.</p>
            <label className="block text-sm font-medium text-foreground mb-1.5">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full h-11 rounded-xl border border-border bg-card px-3 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-primary/40 mb-4"
              data-testid="forgot-email-input" />
            <button type="submit" disabled={busy}
              className="w-full bg-primary text-primary-foreground rounded-xl h-11 text-sm font-semibold btn-anim shadow-soft hover:bg-primary/90 disabled:opacity-50 cursor-pointer"
              data-testid="forgot-submit">
              {busy ? 'Sending…' : 'Send reset link'}
            </button>
            <p className="text-xs text-muted-foreground text-center mt-4">
              Remembered it? <Link to="/auth" className="text-primary font-medium hover:underline">Back to sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
